import React from "react";

import LoadingSpinner from "../../../common/LoadingSpinner";
import Status from "../../../common/management/detail/Status";
import ActionBtn from "../../../common/management/ActionBtn";
import NotificationModal from "../../../common/settings-modal/NotificationModal";
import SelenaA from "../../../assets/img/service/selena-a.webp";

import {
  RequestState,
  genNotificationColor,
  genNotificationMessage,
} from "../../../utils/RequestState";
import { PageVisibility } from "../../../utils/PageVisibility";

import styles from "../db-list/detail/DatabaseDetail.module.scss";

type Props = {
  children: JSX.Element;
  isLoading: boolean;
  requestState: RequestState;
  error: boolean;
  selectStatus?: string;
  setSelectStatus?: (value: string, name: string) => void;
  showStatusMenu?: boolean;
  handleStatusMenu?: () => void;
  handleUpdate: () => void;
};

const FacilityCreate: React.FC<Props> = ({
  children,
  isLoading,
  requestState,
  error,
  selectStatus,
  setSelectStatus,
  showStatusMenu,
  handleStatusMenu,
  handleUpdate,
}) => {
  return (
    <div className={styles["f-databaseDetail"]}>
      {isLoading ? (
        <LoadingSpinner space={1} />
      ) : (
        <>
          <h1 className={styles["f-databaseDetail__title"]}>施設新規作成</h1>
          <div className={styles["f-databaseDetail__inner"]}>
            <div className={styles["f-databaseDetail__head"]}>
              <Status
                isVisibilityStatus={true}
                status={PageVisibility.NotPubliclyVisible}
                selectStatus={selectStatus}
                showStatusMenu={showStatusMenu}
                handleStatusMenu={handleStatusMenu}
                setSelectStatus={setSelectStatus}
              />
            </div>
            {children}
            {error ? (
              <div className={styles["f-databaseDetail__error"]}>
                必須項目が未入力、または入力内容に誤りがあります
              </div>
            ) : null}
            <div className={styles["f-databaseDetail__bottom"]}>
              <ActionBtn
                label=" 保存 "
                onClick={() => handleUpdate()}
                colorReversal={true}
              />
            </div>
            <div className={styles["f-databaseDetail__btn"]}>
              <ActionBtn
                label=" 保存 "
                onClick={() => handleUpdate()}
                colorReversal={true}
              />
            </div>
          </div>
          {requestState !== RequestState.Waiting ? (
            <NotificationModal
              color={genNotificationColor(requestState)}
              message={genNotificationMessage(requestState)}
              img_src={
                requestState === RequestState.Success ? SelenaA : undefined
              }
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default FacilityCreate;
